export default "__VITE_ASSET__CMr$s8La__"